// Theme configuration for multi-tenant branding
// This configuration allows easy customization of logos, colors, and other branding elements per tenant

const themes = {
  initio: {
    logo: 'initio-logo.svg',
    logoType: 'svg',
    favicon: 'favicon.ico',
    colors: {}, // Ready for future color customization
    reportBottomText: 'Initio Software',
    name: 'Initio',
    title: 'Initio Software',
    companyName: 'Initio Software Inc.',
    companyNameUpper: 'INITIO SOFTWARE INC.',
    supportEmail: 'info@initio.software',
    brandName: 'Initio',
  },
  redwoodseed: {
    logo: 'redwoodseed-logo.png',
    logoType: 'png',
    favicon: 'redwoodlogo.png',
    colors: {}, // Ready for future color customization
    reportBottomText: 'Redwood Valuation Partners LLC',
    name: 'Redwood Seed',
    title: 'Redwood Valuation',
    companyName: 'Redwood Valuation Partners LLC.',
    companyNameUpper: 'Redwood Valuation Partners LLC.',
    supportEmail: 'info@redwoodvaluation.com',
    brandName: 'Redwood',
  },
};

export default themes;

